
<template>
  <div class="table-responsive lead_table" style="overflow:initial;" ref="formContainer">
<!--    {{ getUser }}-->
    <table class="table table-hover" id="dataTable" cellspacing="0" >
      <thead style=" border-bottom: 1px solid #93a8d6; border-top: 1px solid #93a8d6;">
        <tr style="background-color: #f4f8fa;">
          <td class="text-left" v-if="flag && checkboxAll">
            <input type="checkbox" class="bg-default" style="cursor: pointer" value="1" v-on:change="changeAllChecboxes()" id="user_parent_row" name="" />
          </td>
          <td class="text-left" v-else-if="flag && !checkboxAll">
            <input type="checkbox" :indeterminate.prop="true" class="bg-default uncheckBox" style="cursor: pointer" value="1" v-on:change="changeAllChecboxes($event)" id="user_parent_row" name="" />
          </td>
          <td v-if="flag"></td>
          <td @click="sort('company')">
            Company
            <span style="cursor: pointer" v-if="flag">
              <svg width="9" height="11" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.98553 8.11346C3.88557 8.11365 3.78869 8.07884 3.71172 8.01506L1.14479 5.87595C1.05742 5.80333 1.00247 5.69898 0.992045 5.58585C0.981615 5.47272 1.01655 5.36008 1.08917 5.27272C1.16179 5.18535 1.26614 5.1304 1.37927 5.11997C1.49239 5.10954 1.60503 5.14448 1.6924 5.2171L3.98553 7.13374L6.27866 5.28555C6.32242 5.25001 6.37277 5.22347 6.42682 5.20746C6.48087 5.19145 6.53756 5.18627 6.59361 5.19224C6.64967 5.1982 6.704 5.21518 6.75347 5.24221C6.80294 5.26924 6.84658 5.30578 6.88189 5.34972C6.92107 5.39371 6.95074 5.44532 6.96905 5.50131C6.98736 5.5573 6.9939 5.61647 6.98828 5.67511C6.98266 5.73375 6.96499 5.79059 6.93637 5.84208C6.90776 5.89358 6.86882 5.9386 6.82199 5.97435L4.25506 8.04073C4.17587 8.09443 4.08098 8.12003 3.98553 8.11346Z"
                  fill="#707070" />
                <path
                  d="M3.99494 0.522284C4.0949 0.522088 4.19178 0.556902 4.26875 0.620682L6.83568 2.7598C6.92305 2.83241 6.97799 2.93677 6.98842 3.04989C6.99885 3.16302 6.96392 3.27566 6.8913 3.36303C6.81868 3.45039 6.71433 3.50534 6.6012 3.51577C6.48808 3.5262 6.37544 3.49126 6.28807 3.41864L3.99494 1.502L1.70181 3.35019C1.65805 3.38573 1.6077 3.41227 1.55365 3.42828C1.49959 3.4443 1.44291 3.44947 1.38686 3.44351C1.3308 3.43754 1.27647 3.42056 1.227 3.39353C1.17753 3.3665 1.13388 3.32997 1.09858 3.28602C1.0594 3.24203 1.02973 3.19042 1.01142 3.13443C0.993112 3.07844 0.986565 3.01927 0.992188 2.96063C0.99781 2.90199 1.01548 2.84515 1.0441 2.79366C1.07271 2.74217 1.11165 2.69714 1.15848 2.6614L3.72541 0.595013C3.8046 0.541315 3.89949 0.515707 3.99494 0.522284Z"
                  fill="#707070" />
              </svg>
            </span>
          </td>
          <td @click="sort('name')">
            Name
            <span style="cursor: pointer" v-if="flag">
              <svg width="9" height="11" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.98553 8.11346C3.88557 8.11365 3.78869 8.07884 3.71172 8.01506L1.14479 5.87595C1.05742 5.80333 1.00247 5.69898 0.992045 5.58585C0.981615 5.47272 1.01655 5.36008 1.08917 5.27272C1.16179 5.18535 1.26614 5.1304 1.37927 5.11997C1.49239 5.10954 1.60503 5.14448 1.6924 5.2171L3.98553 7.13374L6.27866 5.28555C6.32242 5.25001 6.37277 5.22347 6.42682 5.20746C6.48087 5.19145 6.53756 5.18627 6.59361 5.19224C6.64967 5.1982 6.704 5.21518 6.75347 5.24221C6.80294 5.26924 6.84658 5.30578 6.88189 5.34972C6.92107 5.39371 6.95074 5.44532 6.96905 5.50131C6.98736 5.5573 6.9939 5.61647 6.98828 5.67511C6.98266 5.73375 6.96499 5.79059 6.93637 5.84208C6.90776 5.89358 6.86882 5.9386 6.82199 5.97435L4.25506 8.04073C4.17587 8.09443 4.08098 8.12003 3.98553 8.11346Z"
                  fill="#707070" />
                <path
                  d="M3.99494 0.522284C4.0949 0.522088 4.19178 0.556902 4.26875 0.620682L6.83568 2.7598C6.92305 2.83241 6.97799 2.93677 6.98842 3.04989C6.99885 3.16302 6.96392 3.27566 6.8913 3.36303C6.81868 3.45039 6.71433 3.50534 6.6012 3.51577C6.48808 3.5262 6.37544 3.49126 6.28807 3.41864L3.99494 1.502L1.70181 3.35019C1.65805 3.38573 1.6077 3.41227 1.55365 3.42828C1.49959 3.4443 1.44291 3.44947 1.38686 3.44351C1.3308 3.43754 1.27647 3.42056 1.227 3.39353C1.17753 3.3665 1.13388 3.32997 1.09858 3.28602C1.0594 3.24203 1.02973 3.19042 1.01142 3.13443C0.993112 3.07844 0.986565 3.01927 0.992188 2.96063C0.99781 2.90199 1.01548 2.84515 1.0441 2.79366C1.07271 2.74217 1.11165 2.69714 1.15848 2.6614L3.72541 0.595013C3.8046 0.541315 3.89949 0.515707 3.99494 0.522284Z"
                  fill="#707070" />
              </svg>
            </span>
          </td>
          <td v-if="flag">Phone</td>
          <td v-if="flag">Email</td>
          <td v-if="flag">Country</td>
          <td v-if="flag">Website</td>
          <td v-if="flag">Software</td>
          <td v-if="flag">Created At</td>
          <td @click="sort('demo_date_note')" v-if="flag || demo_flag">
            Demo Date
            <span style="cursor: pointer" v-if="flag">
              <svg width="9" height="11" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.98553 8.11346C3.88557 8.11365 3.78869 8.07884 3.71172 8.01506L1.14479 5.87595C1.05742 5.80333 1.00247 5.69898 0.992045 5.58585C0.981615 5.47272 1.01655 5.36008 1.08917 5.27272C1.16179 5.18535 1.26614 5.1304 1.37927 5.11997C1.49239 5.10954 1.60503 5.14448 1.6924 5.2171L3.98553 7.13374L6.27866 5.28555C6.32242 5.25001 6.37277 5.22347 6.42682 5.20746C6.48087 5.19145 6.53756 5.18627 6.59361 5.19224C6.64967 5.1982 6.704 5.21518 6.75347 5.24221C6.80294 5.26924 6.84658 5.30578 6.88189 5.34972C6.92107 5.39371 6.95074 5.44532 6.96905 5.50131C6.98736 5.5573 6.9939 5.61647 6.98828 5.67511C6.98266 5.73375 6.96499 5.79059 6.93637 5.84208C6.90776 5.89358 6.86882 5.9386 6.82199 5.97435L4.25506 8.04073C4.17587 8.09443 4.08098 8.12003 3.98553 8.11346Z"
                  fill="#707070" />
                <path
                  d="M3.99494 0.522284C4.0949 0.522088 4.19178 0.556902 4.26875 0.620682L6.83568 2.7598C6.92305 2.83241 6.97799 2.93677 6.98842 3.04989C6.99885 3.16302 6.96392 3.27566 6.8913 3.36303C6.81868 3.45039 6.71433 3.50534 6.6012 3.51577C6.48808 3.5262 6.37544 3.49126 6.28807 3.41864L3.99494 1.502L1.70181 3.35019C1.65805 3.38573 1.6077 3.41227 1.55365 3.42828C1.49959 3.4443 1.44291 3.44947 1.38686 3.44351C1.3308 3.43754 1.27647 3.42056 1.227 3.39353C1.17753 3.3665 1.13388 3.32997 1.09858 3.28602C1.0594 3.24203 1.02973 3.19042 1.01142 3.13443C0.993112 3.07844 0.986565 3.01927 0.992188 2.96063C0.99781 2.90199 1.01548 2.84515 1.0441 2.79366C1.07271 2.74217 1.11165 2.69714 1.15848 2.6614L3.72541 0.595013C3.8046 0.541315 3.89949 0.515707 3.99494 0.522284Z"
                  fill="#707070" />
              </svg>
            </span>
          </td>
          <td v-if="flag">Est. Value</td>
          <td @click="sort('followup_date')" v-if="temp || demo_flag == false">
            Followup Date
            <span style="cursor: pointer" v-if="flag">
              <svg width="9" height="11" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.98553 8.11346C3.88557 8.11365 3.78869 8.07884 3.71172 8.01506L1.14479 5.87595C1.05742 5.80333 1.00247 5.69898 0.992045 5.58585C0.981615 5.47272 1.01655 5.36008 1.08917 5.27272C1.16179 5.18535 1.26614 5.1304 1.37927 5.11997C1.49239 5.10954 1.60503 5.14448 1.6924 5.2171L3.98553 7.13374L6.27866 5.28555C6.32242 5.25001 6.37277 5.22347 6.42682 5.20746C6.48087 5.19145 6.53756 5.18627 6.59361 5.19224C6.64967 5.1982 6.704 5.21518 6.75347 5.24221C6.80294 5.26924 6.84658 5.30578 6.88189 5.34972C6.92107 5.39371 6.95074 5.44532 6.96905 5.50131C6.98736 5.5573 6.9939 5.61647 6.98828 5.67511C6.98266 5.73375 6.96499 5.79059 6.93637 5.84208C6.90776 5.89358 6.86882 5.9386 6.82199 5.97435L4.25506 8.04073C4.17587 8.09443 4.08098 8.12003 3.98553 8.11346Z"
                  fill="#707070" />
                <path
                  d="M3.99494 0.522284C4.0949 0.522088 4.19178 0.556902 4.26875 0.620682L6.83568 2.7598C6.92305 2.83241 6.97799 2.93677 6.98842 3.04989C6.99885 3.16302 6.96392 3.27566 6.8913 3.36303C6.81868 3.45039 6.71433 3.50534 6.6012 3.51577C6.48808 3.5262 6.37544 3.49126 6.28807 3.41864L3.99494 1.502L1.70181 3.35019C1.65805 3.38573 1.6077 3.41227 1.55365 3.42828C1.49959 3.4443 1.44291 3.44947 1.38686 3.44351C1.3308 3.43754 1.27647 3.42056 1.227 3.39353C1.17753 3.3665 1.13388 3.32997 1.09858 3.28602C1.0594 3.24203 1.02973 3.19042 1.01142 3.13443C0.993112 3.07844 0.986565 3.01927 0.992188 2.96063C0.99781 2.90199 1.01548 2.84515 1.0441 2.79366C1.07271 2.74217 1.11165 2.69714 1.15848 2.6614L3.72541 0.595013C3.8046 0.541315 3.89949 0.515707 3.99494 0.522284Z"
                  fill="#707070" />
              </svg>
            </span>
          </td>
          <td v-if="flag">Assigned</td>
          <td class="pr-2" v-if="flag">Notes</td>
          <td v-if="flag">Status</td>
          <td class="text-right">Actions</td>
        </tr>
      </thead>
      <tbody>
        <tr  v-if="isLoader" id="table_row" >
          <td colspan="17">
            <b-skeleton-wrapper >
                <b-skeleton height="40px" ></b-skeleton>   
                <b-skeleton height="40px"></b-skeleton>  
                <b-skeleton height="40px"></b-skeleton>                                     
            </b-skeleton-wrapper> 
          </td>
        </tr>
        <tr v-show="!isLoader" v-for="(demo, index) in demoRequests" :demo="demo" :key="index" :style="`border-left: 5px solid #${demo.color}`" v-bind:class="[demo.id ? 'id-' + demo.id : '']">
          <!-- Check Box -->
          <td v-if="flag">
            <input type="checkbox" style="cursor: pointer" :data-id="demo.id" class="user_row"  @click="changeCheckbox()" name="" />
          </td>

          <!-- Quick View -->
          <td v-if="flag">
            <a @click="quickView">
              <i :data-id="demo.id" class="fa fa-eye color-default" style="cursor: pointer; margin-bottom: 9px;">
              </i>
            </a>
          </td>
          <!-- company -->
          <b-tooltip  v-if="demo.company.length >= 13" :target="'demo'+demo.id" placement="bottom" style=""> 
              {{ demo.company }}
              </b-tooltip>
          <td v-if="demo.company.length > 13 && flag"  :id="'demo'+demo.id" v-html="demo.company.substring(0, 10) + '...'" ></td>
          <td v-else-if="flag"  v-html="demo.company"></td>
          <td v-if="demo.company.length > 13 && !flag" :id="'demo'+demo.id" v-html="demo.company.substring(0, 10) + '...'">{{ demo.company }}</td>
           <td v-else-if="!flag" v-html="demo.company"></td>
          <!-- name -->
          <td class="text-primary" v-if="demo.name.length > 15">
            <a v-html="demo.name.substring(0, 10) + '...'" hover :title="demo.name" @click="demoDetails(demo.id)"></a>
          </td>
          <td class="text-primary" v-else>
            <a @click="demoDetails(demo.id)">{{
              demo.name
              }}</a>
          </td>
          <!-- phone -->
          <td v-if="flag">
            {{ demo.phone }}
          </td>
          <!-- email -->
          <td v-if="demo.email.length > 15 && flag" v-html="demo.email.substring(0, 10) + '...'" hover :title="demo.email"></td>
          <td v-else-if="flag">{{ demo.email }}</td>
          <!-- country name -->
          <td v-if="flag && demo.country.length > 13" v-html="demo.country.substring(0, 10) + '...'" hover :title="demo.country"></td>
          <td v-else-if="flag">{{ demo.country }}</td>
          <!-- Website -->
          <td v-if="flag && (demo.company_url != null && demo.company_url.length) > 13" v-html="demo.company_url.substring(0, 12) + '...'" hover :title="demo.company_url"></td>
          <td v-else-if="flag">{{ demo.company_url }}</td>
          <!-- Software -->
          <td v-if="flag">
            <span  class="font-weight-bold" style="color:#20CC7D">{{software}}</span>
          </td>
          <td v-if="flag"> {{ demo.created_at | formatDate }}</td>
          <!--Demo Date-->
          <td v-if="flag || demo_flag">
            {{ demo.demo_date_note | formatDate }}
          </td>
          <!--Estimated Value-->
          <td v-if="flag && demo.estimated_value > 0">${{ demo.estimated_value }}</td>
          <td v-else-if="flag">{{ demo.estimated_value }}</td>

          <!-- follow_up_date -->
          <td v-if="(demo.followup_date && flag == false) || flag">
            {{ demo.followup_date | formatDate }}
          </td>
          <td v-else-if="flag == true">{{ demo.created_at | formatDate }}</td>
          <!-- asssign to -->
          <td v-if="flag">
            {{demo.first_name}} {{demo.last_name}} 
          </td>
          <!-- Note -->
          <td v-if="demo.note && flag">
            <p style="cursor: pointer; margin-bottom: 0;" :id="'tooltip-target-' + demo.id">
              View
            </p>
            <b-popover  style="width: max-content;" class="popover" :target="'tooltip-target-' + demo.id" triggers="hover" placement="top">
              <b-alert class="p-0 m-0 small" show variant="light">
                <p class="text-dark mt-0 pt-0" style="font-size: 12px !important">
                  {{ demo.note }}
                </p>
                <div class="row">
                  <div class="col-12 pr-0 mr-0 text-left">
                    <small>{{demo.note_date | formatDate}}</small>
                  </div>
                  <!-- <div class="col-6 pl-0 ml-0 text-right">
                    <small>01:18:05</small>
                  </div> -->
                </div>
                <hr class="mt-2" />
                <a @click="demoDetails(demo.id)" class="btn btn-sm btn-outline-primary" style="font-size: 10px">View All</a>
              </b-alert>
            </b-popover>
          </td>
          <td v-else-if="flag"></td>

          <!-- status -->
          <td v-if="flag" class="pr-0">
            <div class="pl-2 row pr-0" style="cursor: pointer;display:flex;" @mouseover="UpHere(demo.id)" @mouseleave="DownHere()">
              <div v-if="demo.id != edit_id">
                <span v-if="show && demo.status == '0' " style="color: #a682b2; font-weight: 700; font-size: 12px">
                  <span class="bullet">• </span>DISCOVERY</span>
                <span v-if="show && demo.status == '1'" style="color: #66b34d; font-weight: 700; font-size: 12px">
                  <span class="bullet">• </span>QUALIFIED</span>
                <span v-if="show && demo.status == '2' && (selectTab !='4' || selectTab !='5')" style="color: #e95a42; font-weight: 700; font-size: 12px">
                  <span class="bullet">• </span>Dead</span>
                <span v-if="show && demo.status == '3' &&( selectTab !='4' || selectTab !='5') " style="color: #f19a16; font-weight: 700; font-size: 12px">
                  <span class="bullet">• </span>REJECTED</span>
                <span v-if="show && demo.status == '5' &&( selectTab !='4' || selectTab !='5') " style="color: violet; font-weight: 700; font-size: 12px">
                  <span class="bullet">• </span>ONBOARDED</span>
                 <!-- <span v-if="show && demo.org_id != null && selTab == 4 " style="color:DodgerBlue;font-weight: 700; font-size: 12px"> -->
                  <!-- <span class="bullet">• </span>OnBoarding</span>   -->
                <!-- <span v-if="show && demo.org_id != null && selTab == 5 " style="color:rgb(241, 154, 22);; font-weight: 700; font-size: 12px">
                  <span class="bullet">• </span>OnBoarded</span>     -->
                <a v-if="demo.id == demo_id && show && selectTab !='5' && demo.org_id == null" style="color: rgb(72, 166, 166);" class="fa fa-edit pl-3" @click="showDropDown(demo.id)">
                </a>
              </div>
              <div v-if="showstatus && demo.id == edit_id">
                <select class="form-control" style="padding: 0 !important;" :data-status="demo.status" :data-id="demo.id" :data-followup_date="demo.followup_date" v-on:change="changeDemoStatus">
                  <option style="color: #a682b2" value="0" :selected="demo.status == '0'">
                    Discovery
                  </option>
                  <option style="color: #66b34d" value="1" :selected="demo.status == '1'">
                    Qualified
                  </option>
                  <option style="color: #e95a42" value="2" :selected="demo.status == '2'">
                    Dead
                  </option>
                  <option style="color: #f19a16" v-if="demo.status == '3' " value="3" :selected="demo.status == '3'">
                    Rejected
                  </option>
                </select>
              </div>
              <div class="px-1">
                <button v-if="demo.id == edit_id" class="fa fa-check btn btn-success btn-sm" @click="showDropDown(demo.id)"></button>
              </div>
              <div class="">
                <button v-if="demo.id == edit_id" class="fa fa-times btn btn-outline-secondary btn-sm" @click="hideDropDown()"></button>
              </div>
            </div>
          </td>
          <!-- Actions -->

          <td class="text-right">
            <div class="btn-group" v-if="demo.org_id == null">
              <a class="btn dropdown-toggle dropdown_list" data-toggle="dropdown" @click="dropdown_height" href="#">
                <span class="fas fa-ellipsis-v"></span>
              </a>
              <ul class="dropdown-menu dashboard-actions" style="
                  min-width: 10rem !important;
                  color: #48a6a6 !important;
                  border: 1px solid #b6c7d2;
                  border-radius: 8px;
                  font-size: 12px;

                ">
                <a class="dropdown-item my-1" v-if="$can('lead_notes') && (demo.note == null || demo.note == '' || demo.note != null )" @click="createNote" :data-status="demo.status" :data-id="demo.id">Notes</a>
                <a class="dropdown-item my-1" v-if="$can('lead_set_demo_date') && demo.status != 3 && demo.status != 2 && role != 6" @click="setDemoDate" :data-status="demo.status" :data-demo_date="demo.demo_date_note" :data-followup_date="demo.followup_date" :data-id="demo.id" :data-email="demo.email">Set Demo Date</a>
                <a class="dropdown-item my-1" v-if="$can('lead_set_followup_date') && demo.status != 3 && demo.status != 2 && role != 6" @click="suitableDate" :data-status="demo.status" :data-followup_date="demo.followup_date" :data-id="demo.id" >Set Followup Date</a>
                <a class="dropdown-item my-1" v-if="$can('lead_set_estimated_date') && demo.status != 3 && demo.status != 2 && role != 6" @click="estimatedValue" :data-status="demo.status" :data-estimated_value="demo.estimated_value" :data-id="demo.id" >Set Estimated Value</a>
                <a class="dropdown-item my-1" v-if="$can('lead_send_attachment_link') && demo.status != 5 && role != 6" @click="attachmentLink(demo)">Send Attachment Link</a>
                <a class="dropdown-item" v-if="$can('lead_prospection_question') && demo.status != 3 && demo.status != 2 && role != 6" @click="onBoarding" :data-id="demo.id" >Prospection Questions</a>
                <a class="dropdown-item my-1" @click="createOrg" :data-id="demo.id" :data-company="demo.company" :data-website="demo.company_url" :data-phone="demo.phone" :data-name="demo.name" :data-country="demo.country" :data-email="demo.email" :data-lead_for="demo.lead_for" v-if="$can('lead_create_organization') && demo.org_id == null && demo.lead_for == 1 && (demo.status != 2 && demo.status != 3) && role != 6">Create Organization</a>
                <a class="dropdown-item my-1" @click="questionnaireMail" :data-assign_to="demo.assign_to" :data-id="demo.id" :data-name="demo.name" :data-email="demo.email" v-if="$can('lead_send_prospection_mail') && (role == 0 || role == 1) && (demo.status != 2 && demo.status != 3)">Send Prospection Mail</a>
                <a class="dropdown-item my-1" @click="assignLead" :data-assign_to="demo.assign_to" :data-id="demo.id" v-if="$can('lead_assign_lead') && (role == 0 || role == 1) && (demo.status != 2 && demo.status != 3)">Assign Lead</a>
                <a class="dropdown-item my-1" @click="transferLead(demo.id)" v-if="(role == 2)">Transfer Lead</a>
                <a class="dropdown-item my-1" @click="transferLeadHistory(demo.id)" v-if="(role == 2)">Lead Transfer History </a>
                <a class="dropdown-item my-1" :data-status="demo.status" :data-id="demo.id" :data-followup_date="demo.followup_date" @click="RejectLead" v-if="$can('lead_reject') && demo.status != 3 && demo.status != 2">Reject</a>
                <div class="dropdown mt-1" v-if="$can('lead_select_pripority') && demo.status != 3 && demo.status != 2">
                  <a class="dropdown-item" style="display: inline">Select Priority
                    <font-awesome-icon class="ml-5 angle-collapse" icon="angle-right" />
                  </a>
                  <div class="dropdown-content py-2">
                    <button :data-color="demo.color" :data-id="demo.id" v-on:click="changeDemoColor($event, demo.id)" style="color: #a782b2" value="ffff" :selected="demo.color == 'ffff'">
                      <span class="bullet">• </span>No Priority
                    </button>
                    <button :data-color="demo.color" :data-id="demo.id" v-on:click="changeDemoColor($event, demo.id)" style="color: #66b34e" value="66b34e" :selected="demo.color == '66b34e'">
                      <span class="bullet">• </span>Highly interested
                    </button>
                    <button :data-color="demo.color" :data-id="demo.id" v-on:click="changeDemoColor($event, demo.id)" style="color: #f19a16" value="f19a16" :selected="demo.color == 'f19a16'">
                      <span class="bullet">• </span>Interested
                    </button>
                    <button :data-color="demo.color" :data-id="demo.id" v-on:click="changeDemoColor($event, demo.id)" style="color: #e95a42" value="e95a42" :selected="demo.color == 'e95a42'">
                      <span class="bullet">• </span>Less interested
                    </button>
                  </div>
                </div>
                <hr v-if="demo.status != 3 && demo.status != 2" width="75%" class="mx-auto" />
                <a class="dropdown-item mb-1" v-if="$can('lead_edit')" @click="editLead(demo)">Edit</a>
                <a class="dropdown-item router-link dashboard-action" v-if="$can('lead_detail')" @click="demoDetails(demo.id)">
                  Details
                </a>
                <a class="dropdown-item text-danger my-1" @click="deleteDemo" :data-status="demo.status" :data-id="demo.id" v-if="$can('lead_select_pripority') && (role == 0 || role == 1) && demo.org_id == null">Delete</a>
              </ul>
            </div>
          </td>
        </tr>
        <tr v-if="demoRequests.length < 1 && !isLoader" style="height: 32.2vh">
          <td colspan="17">
            <h6 class="text-center">No Data Found!</h6>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- Pagination  -->
      <div v-if="!isLoader" class="row mt-1 justify-content-end d-flex align-items-center px-3">
        <div class="pt-0 display-rows">
          <span class="pr-3 font-weight-light">Total Leads</span>
          <span class="pr-5 color-default text-decoration-underline font-weight-bold">{{ total_demo }}</span>
          <span class="pr-3 font-weight-light">Display Rows</span><span class="pr-5 mr-3 color-default font-weight-bold text-decoration-underline">{{ totalRows }}</span>
        </div>
        <paginate  v-show="totalRows > 0" v-model="currentPage" :page-count="totalPages" :click-handler="setPage" :prev-text="''" :next-text="''" :first-button-text="''" :last-button-text="''" :first-last-button="true" :container-class="'pagination pagination-sm mb-0'" :page-class="'page-item'" :prev-class="'page-item prev'" :next-class="'page-item next'" :page-link-class="'page-link'" :prev-link-class="'page-link'" :next-link-class="'page-link'"></paginate>
      </div>
  </div>
</template>

<script>
  import moment from "moment";
  import $ from "jquery";

  Vue.filter("formatDate", function (value) {
    if (value != "0000-00-00 00:00:00" && value != null) {
      return moment(String(value)).format("MMM DD, Y LT");
    }
  });
  import noteForm from "./note_form";
  import demoDate from "./demo_date_form";
  import suitableForm from "./demo_suitabledate_form";
  import EstimatedForm from "./estimated_value_form";
  import deleteForm from "./demo_delete_form";
  import rejectForm from "./rejectedForm.vue";
  import OrgForm from "./create_org_form.vue";
  import boardingForm from "./onboarding_form.vue";
  import lead_quickView from "./lead_quickView.vue";
  import "vue-loading-overlay/dist/vue-loading.css";
  import assigLead from '../leads/assign_lead_form.vue';
  import editLead from "../leads/edit_lead.vue";
  import transferLead from '../leads/transfer_lead_form.vue';
  import transferLeadHistory from '../leads/transfer_lead_form_history.vue';
  import axios from 'axios';
  export default {
    props: [
      "demo",
      "demoRequests",
      "totalPages",
      "page",
      "title",
      "flag",
      "demo_flag",
      "temp",
      "selTab",
      "followup_filter",
      "colorFilter",
      "total_demo",
      "totalRows",
      "assign_filter",
      "crm_id",
      "setskeletonLoader",
      "tag","from_date","to_date"
    ],
    data() {
      return {
        isLoader: true,
        myDate: "",
        st: "",
        role: '',
        show: true,
        dots: false,
        showstatus: false,
        upHere: false,
        checkAll: true,
        search: "",
        demo_id: "",
        edit_id: "",
        lead_status: "",
        lead_id: "",
        awaitingSearch: false,
        note: "",
        note_date: "",
        selectTab: "",
        message: "",
        created_at: "",
        suitable_date: "",
        status: 'all',
        countUnchecked: 0,
        checkboxAll: true,
        sortDirection: {
          company: true,
          name: true,
          followup_date: true,
          demo_date_note: true,
        },
        adminUsers:[],
        value:[],
        showCog:false,
        cogTypes:[],
        cogOptionsSelected:[],
        software:''
      };
    },
    computed: {
      currentPage: {
        get: function () {
          this.showstatus = false;
          this.selectTab = localStorage.getItem("tab");
          return this.page;
        },
        set: function () { },
      },
      // getUser(){
      // this.$store.dispatch('users/assignToUser');
      //
      // },
      tags: function(){
        return this.$store.getters["users/tags"];
      },
      showskLoader: function () {
        this.isLoader = this.setskeletonLoader;
        return this.setskeletonLoader;
      },
      availableProducts: function () {
        return this.$store.getters['persist/availableProducts'];
      },
    },
    mounted: function () {
     
      // if($( window ).width() > 1400 && this.$route.fullPath.indexOf('/demo-leads') != -1){
      //   $('.lead_table').on('show.bs.dropdown', function () {
      //       $('.lead_table').css( "overflow", "initial" );
      //       $('ul.dropdown-menu.dashboard-actions.show').css( "transform", "translate3d(-132px, -240px, 0px)" );

      //   });
      //   $('.lead_table').on('hide.bs.dropdown', function () {
      //       $('.lead_table').css( "overflow", "visible" );
      //   });
      // }       
      // if($( window ).width() >= 1280 && $( window ).width()<= 1366 && this.$route.fullPath.indexOf('/demo-leads') != -1){
      //   $('.lead_table').on('show.bs.dropdown', function () {
      //       $('.lead_table').css( "overflow", "overlay" );
      //       $('ul.dropdown-menu.dashboard-actions.show').css( "transform", "translate3d(-132px, -240px, 0px)" );
      //       $('.lead_table').css( "minHeight", "400px" );
            

      //   });
      //   $('.lead_table').on('hide.bs.dropdown', function () {
      //       $('.lead_table').css( "overflow", "scroll" );
      //       $('.lead_table').css( "minHeight", "auto" );
      //   });
      //   this.$el.querySelector(".table").style.width = '1880px';
      //   this.$el.querySelector("#action_dropdown_height").style.maxWidth = '1880px';
      //   this.$el.querySelector("#action_dropdown_height").style.width = '1880px';
      //   this.$el.querySelector("table tr td:nth-child(1)").style.width =  '0.5% ';
      //   this.$el.querySelector("table tr td:nth-child(1)").style.padding =  '0.5rem 0.25rem';
      //     this.$el.querySelector("table tr td:nth-child(4)").style.padding =  '0.7rem 0.3rem';
      //   this.$el.querySelector("table tr td:nth-child(2)").style.width =  '1%';
      //   this.$el.querySelector("table tr td:nth-child(3)").style.width =  '8%';
      //   this.$el.querySelector("table tr td:nth-child(4)").style.width =  '8.5%';

      // }else if( this.$route.fullPath.includes('/demo-leads')){
      //   this.$el.querySelector("table tr td:nth-child(1)").style.width =  '0.5% ';
      //   this.$el.querySelector("table tr td:nth-child(2)").style.width =  '1%';
      //   this.$el.querySelector("table tr td:nth-child(3)").style.width =  '8%';
      //   this.$el.querySelector("table tr td:nth-child(3)").style.width =  '8.5%';
      // }
      this.isLoader = this.setskeletonLoader;
      this.role = localStorage.getItem('role');
      this.showstatus =false;
      this.edit_id = false;
      const permission = {
        headers: {
          'X-Permission': 'lead_list'
        }
      };
      axios.get('/admin/users/get-all-users?role_id=' + 2,permission)
          .then((response) => {
            let res = response.data;
            this.adminUsers = res.data;
          });
    },
    watch:{
      showskLoader: function () {
        this.selectTab = localStorage.getItem("tab");
        this.isLoader = this.setskeletonLoader;
        return this.setskeletonLoader;
      },
      demoRequests: {
            handler: function () {
              this.software = localStorage.getItem('product_name');
            },
            deep: true
          },
      } ,
   
    
    methods: {
      setPage(page) {
        //  console.log(localStorage.getItem('setPageDirection'));
        this.$emit("setPage",page,this.from_date,this.to_date);
      //   if($( window ).width() > 1400 && this.$route.fullPath.indexOf('/demo-leads') != -1){
      //     $('.lead_table').on('show.bs.dropdown', function () {
      //         $('.lead_table').css( "overflow", "initial" );
      //         $('ul.dropdown-menu.dashboard-actions.show').css( "transform", "translate3d(-132px, -240px, 0px)" );

      //     });
      //     $('.lead_table').on('hide.bs.dropdown', function () {
      //         $('.lead_table').css( "overflow", "visible" );
      //     });
      //   }       
      //   if($( window ).width() >= 1280 && $( window ).width()<= 1366 && this.$route.fullPath.indexOf('/demo-leads') != -1){
      //     $('.lead_table').on('show.bs.dropdown', function () {
      //         $('.lead_table').css( "overflow", "overlay" );
      //         $('ul.dropdown-menu.dashboard-actions.show').css( "transform", "translate3d(-132px, -240px, 0px)" );
      //         $('.lead_table').css( "minHeight", "400px" );
              

      //     });
      //     $('.lead_table').on('hide.bs.dropdown', function () {
      //         $('.lead_table').css( "overflow", "scroll" );
      //         $('.lead_table').css( "minHeight", "auto" );
      //     });
      //     this.$el.querySelector(".table").style.width = '1880px';
      //     this.$el.querySelector("#action_dropdown_height").style.maxWidth = '1880px';
      //     this.$el.querySelector("#action_dropdown_height").style.width = '1880px';
      //     this.$el.querySelector("table tr td:nth-child(1)").style.width =  '0.5% ';
      //     this.$el.querySelector("table tr td:nth-child(1)").style.padding =  '0.5rem 0.25rem';
      //       this.$el.querySelector("table tr td:nth-child(4)").style.padding =  '0.7rem 0.3rem';
      //     this.$el.querySelector("table tr td:nth-child(2)").style.width =  '1%';
      //     this.$el.querySelector("table tr td:nth-child(3)").style.width =  '8%';
      //     this.$el.querySelector("table tr td:nth-child(4)").style.width =  '8.5%';

      //   }else if( this.$route.fullPath.includes('/demo-leads')){
      //     this.$el.querySelector("table tr td:nth-child(1)").style.width =  '0.5% ';
      //     this.$el.querySelector("table tr td:nth-child(2)").style.width =  '1%';
      //     this.$el.querySelector("table tr td:nth-child(3)").style.width =  '8%';
      //     this.$el.querySelector("table tr td:nth-child(3)").style.width =  '8.5%';
      //   }
      },
      sort(column) {
        this.$emit("setPage",1,this.from_date,this.to_date);
        // this.isLoader = true;

        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        let color = this.colorFilter;
        let status = localStorage.getItem('tab'); 
        let direction = this.sortDirection[column];
        localStorage.setItem('direction', direction); 
        localStorage.setItem('column', column);
          // let abc = localStorage.getItem('setPageDirection');
        if(localStorage.getItem('setPageDirection') =='false' && direction == true){
          localStorage.setItem('direction', false);
          direction = false;
          this.sortDirection[column] = false;
        }
        
        // this.$store.dispatch("users/getAllDemoRequests", [1, "", status, "", "", "", "", direction == true  ? "asc" : "desc", column])
        //   .then(() => {
        //     // loader.hide();
        //     this.isLoader = false;
            
        //   });
        this.sortDirection[column] = !this.sortDirection[column];
        localStorage.setItem('setPageDirection', this.sortDirection[column]);
      },
      changeAllChecboxes() {
        let self = this;
        this.checkboxAll =true;
        self.checkAll = !self.checkAll;
        let children = this.$el.querySelectorAll(".user_row");
        for (var i = 0; i < children.length; i++) {
          children[i].checked = !self.checkAll;
        }
      },
      changeCheckbox(){      
        this.countUnchecked = 0;
        let self = this;
        let children = this.$el.querySelectorAll(".user_row");
        let checkboxParent = this.$el.querySelectorAll(".uncheckBox");
        for (var i = 0; i < children.length; i++) {
          if(children[i].checked== false){
            this.countUnchecked++;
          }
          this.countUnchecked > 0 && this.countUnchecked < 50 ? this.checkboxAll = false : this.checkboxAll =true;
          if(this.countUnchecked == 50 && this.checkboxAll ==true){
            for (var i = 0; i < checkboxParent.length; i++) 
            // checkboxParent[i].checked = false;
            checkboxParent[i].checked = false;
            self.checkAll = true;
          }
        }
      },
      UpHere(id) {
        this.demo_id = id;
      },
      DownHere() {
        this.demo_id = false;
      },
      showDropDown(id) {
        if (!this.showstatus) {
          this.edit_id = id;
          this.showstatus = true;
        }else {
          this.edit_id = false;
          this.showstatus = false;
          // this.showstatus = true;
          if (this.lead_id == id) {
            // let loader = this.$loading.show({
            //   loader: "dots",
            //   container: this.fullPage ? null : this.$refs.formContainer,
            // });
            this.isLoader = true;
            let color = this.colorFilter;
            this.$store.dispatch("users/changeDemoStatus", [this.lead_status, id, ""])
              .then(() => {
                // loader.hide();
                this.isLoader = false;
                
                this.$toast.success("Status Changed Successfully");
              });
            this.lead_status = "";
            this.edit_id = false;
            this.lead_id = false;
            this.showstatus = false;
            this.$store.dispatch("users/getAllDemoRequests", [this.page, "", localStorage.getItem('tab'), "", "", "", "", "", "", color ? color : "", this.followup_filter, 'all' , localStorage.getItem('software_filter'),'all','all','',this.from_date,this.to_date]);
          }
        }
      },
      hideDropDown() {
        this.edit_id = false;
        this.showstatus = false;
      },
      changeDemoStatus(event) {
        this.lead_id = event.target.dataset.id;
        this.lead_status = event.target.value;
      },

      RejectLead(event) {
        let status = 3;
        let id = event.target.dataset.id;
        let color = this.colorFilter;
        let tab = "";
        if (this.selTab == "") {
          tab = 'all';
        } else {
          tab = localStorage.getItem('tab');
        }
        let pageNumber = this.page;
        this.$store.dispatch("modal/createRejectForm", {
          action: "create",
          title: "Rejection Reason",
          formData: {
            user: id,
            page: pageNumber,
            status: status,
            color: color,
            tab: tab,
          },
          component: rejectForm,
        });
      },

      dropdown_height(event){
        this.$el.querySelectorAll("#action_dropdown_height").style.minHeight = '400px ';
      },

      changeDemoColor(event, demo_id) {
        var id = event.target.dataset.id;
        var demo_color = event.target.value;
        var color = this.colorFilter;
        var demo_class = ".id-" + demo_id;
        $(demo_class).css("background-color", demo_color);
        this.$store
          .dispatch("users/changeDemoColor", [demo_color, id])
          .then(() => {
            // this.$toast.success("Priority Set Successfully");
          });
        const _self = this;
        function sleep(ms) {
          return new Promise((resolve) => setTimeout(resolve, ms));
        }
        async function demo() {
          // await sleep(2000);
          $(demo_class).css("background-color", color);
          _self.changeColor(color);
        }
        demo();
      },
      changeColor(event) {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.isLoader = true;
        this.$store.dispatch("users/getAllDemoRequests", [this.page,"",this.selTab, "","", "","","","",event ? event : "",this.followup_filter,'all','all','all','','',this.from_date,this.to_date])
          .then(() => {
            // loader.hide();
            this.isLoader = false;

            this.$toast.success("Priority Set Successfully");
          });
      },
      createNote(event) {
        let user = event.target.dataset.id;
        let status = localStorage.getItem('tab');
        let pageNumber = this.page;
        let color = this.colorFilter;
        this.$store.dispatch("modal/update", {
          action: "create",
          title: "Notes",
          formData: {
            user: user,
            pageNumber: pageNumber,
            status: status,
            color: color,
            followup_filter: this.followup_filter
          },
          component: noteForm,
        });
      },
      quickView(event) {
        let user = event.target.dataset.id;
        let status = localStorage.getItem('tab');
        let pageNumber = this.page;
        let color = this.colorFilter;
        this.$store.dispatch("modal/quickView", {
          action: "create",
          title: "",
          formData: {
            user: user,
            pageNumber: pageNumber,
            status: status,
            color: color,
            software : this.software
          },
          component: lead_quickView,
        });
      },
      createOrg(event) {
          let status = localStorage.getItem('tab');
          let pageNumber = this.page || 1;
          let color = this.colorFilter || "default";
          let lead_id = event.target.dataset.id;
          let company = event.target.dataset.company;
          let email = event.target.dataset.email;
          let phone = event.target.dataset.phone;
          let name = event.target.dataset.name;
          let website = event.target.dataset.website;
          let country = event.target.dataset.country;
          let lead_status = event.target.dataset.lead_for;

          this.$store.dispatch("modal/createOrg", {
            action: "create",
            title: "Create Organization",
            formData: {
              lead_id,
              company,
              email,
              phone,
              name,
              website,
              country,
              pageNumber,
              status,
              color,
              lead_status: 0,
            },
            component: OrgForm,
          });
      },
      assignLead(event) {
        let lead_id = event.target.dataset.id;
        let assign_to = event.target.dataset.assign_to;
        let pageNumber = this.page;
        let status = localStorage.getItem('tab');
        let color = this.colorFilter;
        this.$store.dispatch("modal/assignLead", {
          action: "create",
          title: "LEAD ASSIGN",
          formData: {
            lead_id: lead_id,
            pageNumber: pageNumber,
            status: status,
            color: color,
            followup_filter: this.followup_filter,
            assign_to: assign_to,
            assign_filter:this.assign_filter,
            crm_id: this.crm_id,
          },
          component: assigLead,
        });
      },
      questionnaireMail(event){
        const lead_schedule_demo_id    = event.target.dataset.id;
        const lead_schedule_demo_name  = event.target.dataset.name;
        const lead_schedule_demo_email = event.target.dataset.email;
        this.$store.dispatch('users/scheduleDemoMailAjax', [lead_schedule_demo_id, lead_schedule_demo_name, lead_schedule_demo_email]).then((resp) => {
          if(resp.error){
            this.$toast.error(resp.error);
          }else{
            this.$toast.success(`Lead for schedule demo has been sent!`);
          }
        })
        .catch((error) => {
          this.$toast.error(error);
        });
      },
      transferLead(lead_id) {
        let pageNumber = this.page;
        let status = localStorage.getItem('tab');
        let color = this.colorFilter;
        this.$store.dispatch("modal/transferLead", {
          action: "create",
          title: "Transfer Lead",
          formData: {
            lead_id: lead_id,
            pageNumber: pageNumber,
            status: status,
            color: color,
            flag:this.flag,
            followup_filter: this.followup_filter
          },
          component: transferLead,
        });
      },
      transferLeadHistory(lead_id) {
        let pageNumber = this.page;
        let status = localStorage.getItem('tab');
        let color = this.colorFilter;
        this.$store.dispatch("modal/transferLeadHistory", {
          action: "create",
          title: "Lead Transfer History",
          formData: {
            lead_id: lead_id,
            pageNumber: pageNumber,
            status: status,
            color: color,
            followup_filter: this.followup_filter
          },
          component: transferLeadHistory,
        });
      },

      editLead(demo) {
        this.cogOptionsSelected = [];
        this.cogTypes = [];
        this.showCog = false;
        this.value = [];
        let selected_tags_array=[];
        let tags_arr = demo.hasOwnProperty('tags') ? demo.tags :[];
        let all_tags_arr = this.tags;
        let assigned_to_user = [];
        let assign_to_user = this.adminUsers;
        let user = demo.assign_to;
        let selected_tag_ids = [];
        if(tags_arr.length > 0){
          selected_tag_ids = tags_arr.map(({ tag_id }) => tag_id);
          all_tags_arr.forEach((key) => {
          if(selected_tag_ids.includes(key.id)){
            selected_tags_array.push({id:key.id,tag:key.tag});
          }   
          });
        }
        assign_to_user.forEach((key) => {
        if(user == key.id){
          assigned_to_user.push({id:key.id,full_name:key.full_name});
        }   
        });
        this.cogTypes = demo.cog_type != null? demo.cog_type.split(','): [];
            if (demo.rental == 1) {
                this.value.push('Linen Rentals');
            }
            if (demo.cog == 1) {
                this.value.push('Customer Owned Goods');
                this.showCog = true;
                if(this.cogTypes){
                    if (this.cogTypes.indexOf('1') != -1) {
                        this.cogOptionsSelected.push({ name: 'By Piece', value: '1' });
                    }
                    if(this.cogTypes.indexOf('2') != -1) {
                        this.cogOptionsSelected.push({ name: 'By Weight', value: '2' });
                    }    
                }    
            }
            if (demo.dry_cleaning == 1) {
                this.value.push('Dry Cleaning');
            }
        let color = this.colorFilter;
        let assign_filter = this.assign_filter;
        let crm_id = this.crm_id;
        let status = localStorage.getItem('tab');
        this.$store.dispatch("modal/editLead", {
          action: "create",
          title: "Edit Lead",
          formData: {
            page:this.page,
            lead_id: demo.id,
            company: demo.company,
            status: status,
            followup_filter: this.followup_filter,
            email: demo.email,
            phone: demo.phone,
            lead_for: demo.lead_for,
            name: demo.name,
            company_url: demo.company_url,
            country: demo.country,
            services: this.value,
            hear_about: demo.hear_about,
            implement_date: demo.implement_date,
            color: color,
            assign_filter: assign_filter,
            crm_id: crm_id,
            number_of_decion_makers:demo.number_of_decion_makers,
            number_of_employees: demo.number_of_employees,
            close_date: demo.close_date,
            street_address:demo.street_address,
            postal_code: demo.postal_code,
            timezone: demo.timezone,
            year_founded: demo.year_founded,
            facebook: demo.facebook,
            goole_plus: demo.goole_plus,
            linked_in:demo.linked_in,
            twitter:demo.twitter,
            job_title:demo.job_title,
            tags:selected_tags_array,
            all_tags:this.tags,
            tag_filter:this.tag,
            cog_types:this.cogOptionsSelected,
            show_cog_types:this.showCog,
            assign_to: assigned_to_user,
            admin_users: this.adminUsers,
            lead_for: demo.lead_for,
          },
          component: editLead,
        });
      },
      setDemoDate(event) {
        let user = event.target.dataset.id;
        let pageNumber = this.page;
        let followup_date = event.target.dataset.followup_date;
        let email = event.target.dataset.email;
        let demo_date = event.target.dataset.demo_date;
        let status = localStorage.getItem('tab');
        let color = this.colorFilter;
        this.$store.dispatch("modal/DemoDateUpdate", {
          action: "create",
          title: "Demo Note",
          formData: {
            user: user,
            pageNumber: pageNumber,
            demo_date: demo_date,
            followup_date: followup_date,
            email: email,
            status: status,
            followup_filter: this.followup_filter,
            color: color, 
          },
          component: demoDate,
        });
      },
      suitableDate(event) {
        let user = event.target.dataset.id;
        let followup_date = event.target.dataset.followup_date;
        let pageNumber = this.page;
        let status = localStorage.getItem('tab');
        let color = this.colorFilter;
        this.$store.dispatch("modal/suitableDateUpdate", {
          action: "create",
          title: "Demo Followup Date",
          formData: {
            user: user,
            pageNumber: pageNumber,
            followup_date: followup_date,
            status: status,
            followup_filter: this.followup_filter,
            color: color,
          },
          component: suitableForm,
        });
      },
      estimatedValue(event) {
        let user = event.target.dataset.id;
        let pageNumber = this.page;
        let status = localStorage.getItem('tab');
        let est_value = event.target.dataset.estimated_value;
        let color = this.colorFilter;
        this.$store.dispatch("modal/EstimatedValue", {
          action: "create",
          title: "Estimated Value",
          formData: {
            user: user,
            pageNumber: pageNumber,
            estimated_value: est_value,
            status: status,
            followup_filter: this.followup_filter,
            color: color,
          },
          component: EstimatedForm,
        });
      },
      onBoarding(event) {
        let lead_id = event.target.dataset.id;
        this.$store.dispatch("modal/onBoarding", {
                action: "create",
                title: "Processing Type (Please select what represents the major part of your business e.g) If its 70 percent rentals and 30 percent COG then select rentals",
                formData: {
                    lead_id: lead_id
                },
                component: boardingForm,
            });
      },
      deleteDemo(event) {
        let user = event.target.dataset.id;
        let pageNumber = this.page;
        let status = localStorage.getItem('tab');
        let color = this.colorFilter;
        this.$store.dispatch("modal/deleteDemoRequest", {
          action: "create",
          title: "Delete Lead",
          formData: {
            user: user,
            pageNumber: pageNumber,
            status: status,
            followup_filter: this.followup_filter,
            color: color,
          },
          component: deleteForm,
        });
      },
      demoDetails(id){

        this.$router.push('/demo-leads/detail/'  + id);
      },
      attachmentLink(lead){
        this.$toast.success("Attachment link will be send in few moments...");
        this.$store.dispatch("users/dataAttachmentLink", [lead.id,'',true]);          
      },  
    },
  };
</script>
<style>

  /* ul.dropdown-menu.dashboard-actions.show {
    transform: translate3d(-132px, -240px, 0px) !important;
  } */
  .form-control {
    font-size: 13px;
  }

  .popover {
    white-space: pre-line;
    max-width: 221.34px;
    font-family: Mulish, sans-serif;
    font-size: 16px;
    font-weight: 400;
    border: 1px solid #9fb4c3;
    border-radius: 8px;
    padding: 8px;
  }

  /* .tooltip {
    border: 1px solid black;
  } */

  .demo {
    margin-top: 5px;
    background: azure;
  }

  .dropdown {
    position: relative;
    display: inline-block;
  }

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: white;
    width: 140px;
    border-radius: 10px;
    border: 1px solid #b6c7d2;
    right: 100%;
    z-index: -1;
    margin-top: -30px;
  }

  .dropdown-content button {
    display: block;
    width: 100%;
    text-align: left;
    padding: 0px 0 5px 15px;
  }

  .dropdown-content button:hover {
    border-radius: 2px;
    background-color: #edf2f5;
  }

  .dropdown:hover .dropdown-content {
    display: block;
  }

  a.btn:focus {
    background-color: #48a6a6;
    color: white;
  }

  .dropdown-menu a:hover {
    border-radius: 2px;
    color: white;
    background-color: #48a6a6;
  }

  .discovery_status {
    color: #a682b2;
    font-weight: 700;
    font-size: 12px;
  }

  .qualified_status {
    color: #a682b2;
    font-weight: 700;
    font-size: 12px;
  }

  .dead_status {
    color: #a682b2;
    font-weight: 700;
    font-size: 12px;
  }

  .reject_status {
    color: #a682b2;
    font-weight: 700;
    font-size: 12px;
  }
  .tooltip{
    border: 0px solid black !important;
    top: -24px !important;
  }
  .tooltip.bs-tooltip-top{
     top: 24px !important;
  }
  .tooltip .tooltip-inner {
    max-width: 200px !important;
    padding: 0.25rem 0.5rem !important;
    color: #000000de !important;
    text-align: center !important;
    background-color: #dbddde !important;
    border-radius: 0.25rem !important;
    font-size: 12px !important;
    font-weight: 500 !important;
  }
</style>

<style scoped>

   table tr td:not(:nth-child(1)):not(:nth-child(4)){
     padding: 0.75rem 0.3rem;
   }
  tbody tr{
    font-size: 13px !important; 
  }
  /* table tr td:nth-child(1) {
   
    padding: 0.5rem 0.25rem;
  } */
 

  table tr td:nth-child(4) {
    width: 8.5% !important;
  }

  table tr td:nth-child(5) {
    width: 6% !important;
  }

  table tr td:nth-child(6) {
    width: 6% !important;
  }

  table tr td:nth-child(7) {
    width: 6% !important;
  }

  table tr td:nth-child(8) {
    width: 3% !important;
  }

  table tr td:nth-child(9) {
    width: 5% !important;
  }
   table tr td:nth-child(10) {
    width:7.5% !important;
  }

  table tr td:nth-child(11) {
    width: 7% !important;
  }

  table tr td:nth-child(12) {
    width: 7.5% !important;
    padding: 0;
  }

  table tr td:nth-child(13) {
    width: 8.5% !important;
  }

  table tr td:nth-child(14) {
    width: 5% !important;
  }

  table tr td:nth-child(15) {
    width: 5% !important;
    padding: 0;

  }

  table tr td:nth-child(16) {
    width: 11% !important;
    padding: 0.75rem 0.5rem;
  }
  table tr td:nth-child(17) {
    width: 1.5% !important;
    padding: 0.75rem 0.5rem;
  }
  .text-primary{
    color: rgb(72, 166, 166) !important;
  }
</style>